import { FormEvent, useContext, useEffect, useRef, useState } from "react"
import { SearchContext, SearchContextType } from "../provider/SearchProvider"

export default function SearchBox() {
  const { search, searchTerm } = useContext(SearchContext) as SearchContextType;
  const searchBox = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (searchBox.current) {
      searchBox.current.value = searchTerm;
      searchBox.current.focus();
    }
  }, [])

  const onFormSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    search(searchBox.current?.value ?? '');
  };

  return (
    <form className="searchbox-form"
      onSubmit={onFormSubmit}>
      <input type="text" className="form-control" placeholder="Search..." ref={searchBox} />
      <button type='submit'><span className="fa fa-search" aria-hidden="true"></span></button>
    </form>
  )
}